import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/Disbursements';

export const disbursementEndpoints = {
  list: () => buildEndpoint(BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  getByVoucher: (voucherNumber: string) => buildEndpointWithParams(`${BASE_PATH}/voucher/:voucherNumber`, { voucherNumber }),
  create: () => buildEndpoint(BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  delete: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  basePath: () => BASE_PATH,
} as const;

export default disbursementEndpoints;
